import './InfiniteLoader.css';
const InfiniteLoader = () => {
    return (
        <div className="dot-wave">
            <div className="dot-wave__dot"></div>
            <div className="dot-wave__dot"></div>
            <div className="dot-wave__dot"></div>
            <div className="dot-wave__dot"></div>
        </div>
    );
};

export default InfiniteLoader;